import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

export default class CheckLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: true,
    };
  }

  async componentDidMount() {
    await this.getLoginState();
  }

  async getLoginState() {
    this.setState({ loggedIn: await StorageHandler.load(storageKeys.user) });
  }

  render() {
    const { loggedIn } = this.state;
    return <div>{!loggedIn && <Redirect to="/sso" />}</div>;
  }
}
